import { TextField } from '@mui/material';
import NumberFormatInputWrapper from './NumberFormatInputWrapper';
import React from 'react';

const NumberFormatTextField = props => {
  const { inputProps, InputProps, InputLabelProps, value, ...rest } = props;

  const { shrink, ...InputLabelRest } = InputLabelProps || {};

  return (
    <TextField
      value={value}
      slotProps={{
        input: {
          inputComponent: NumberFormatInputWrapper,
          ...InputProps
        },
        htmlInput: inputProps,
        inputLabel: {
          shrink: shrink !== undefined ? shrink : value || value === 0 ? true : undefined,
          ...InputLabelRest
        }
      }}
      {...rest}
    />
  );
};

export default NumberFormatTextField;
